import { Grid, GridProps } from '@mui/material';
import { FC } from 'react';
export * from './element';

type Props = {
  spacing?: number;
  children: GridProps['children'];
};

export const DataGrid: FC<Props> = ({ children, spacing = 3 }) => {
  return (
    <Grid container spacing={spacing}>
      {children}
    </Grid>
  );
};
